import RouterService from '@/service/RouterService'
import BaseAbstract from '@/abstract/BaseAbstract'
import IOService from '@/service/IOService'

class ConfigOptionService extends BaseAbstract {
  displayName = '选项'
  name = 'ConfigOption'
  index (params: { page: number }) {
    return IOService.get('config_option', {
      ...params,
      config_id: RouterService.query('config_id')
    })
  }

  store (params: object) {
    return IOService.post('config_option', params)
  }

  show (id: number) {
    return IOService.get(`config_option/${id}`)
  }

  update (params: { id: number }) {
    return IOService.put(`config_option/${params.id}`, params)
  }

  destroy (id: number) {
    return IOService.delete(`config_option/${id}`)
  }
}

export default new ConfigOptionService()
